<ag-grid-angular
  class="
    ag-theme-alpine ag-theme-lum ag-theme-lum--next lum-c-cost-layers-basic-table
  "
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [domLayout]="domLayout ?? 'normal'"
  (gridReady)="handleGridReady($event)"
></ag-grid-angular>
